import { render, staticRenderFns } from "./jb-editor.vue?vue&type=template&id=07c6d98e&scoped=true"
import script from "./jb-editor.vue?vue&type=script&lang=ts"
export * from "./jb-editor.vue?vue&type=script&lang=ts"
import style0 from "./jb-editor.vue?vue&type=style&index=0&id=07c6d98e&scoped=true&lang=scss"
import style1 from "./jb-editor.vue?vue&type=style&index=1&id=07c6d98e&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c6d98e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07c6d98e')) {
      api.createRecord('07c6d98e', component.options)
    } else {
      api.reload('07c6d98e', component.options)
    }
    module.hot.accept("./jb-editor.vue?vue&type=template&id=07c6d98e&scoped=true", function () {
      api.rerender('07c6d98e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/jb-editor.vue"
export default component.exports